import DiscussLogFile from './DiscussLogFile';

export default DiscussLogFile;
